import React, { useContext } from 'react'
import { Alert, Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import Button from '@mui/material/Button'

import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import BackEndAPI from '../../../Services/BackEndAPI'
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces'
import { MensagemTipo } from '../../../GlobalStates/MensagemState'

export default function DevicesAtualizar () {

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface

  const { mensagemState, setMensagemState } = contexto

  const clsApi: BackEndAPI = new BackEndAPI()

  const navigate = useNavigate()

  const btExecutar = () => {

    const queryToken = `
      receberTokenDevice
    `

    clsApi.query<string>( queryToken, 'receberTokenDevice', 'Obtendo Autorização...', contexto ).then( token => {

      const mutation = `
        atualizarDevice(token: "${token}") {
          ok
          mensagem
        }
      `

      clsApi.mutation<RespostaPadraoInterface>( mutation, 'atualizarDevice', 'Atualizando Devices...', contexto ).then( rs => {

        setMensagemState( {
          ...mensagemState,
          titulo: rs.ok ? 'Sucesso!' : 'Erro!',
          exibir: true,
          mensagem: rs.mensagem,
          tipo: rs.ok ? MensagemTipo.Info : MensagemTipo.Error,
          exibirBotao: true
        } )

      } )

    } )

  }

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Atualizar Devices
              </Typography>

              <IconButton onClick={() => navigate( '/' )}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} sx={{ mb: 3 }}>
              <Alert severity="warning">
                Este procedimento irá analisar o Diretório Ativo, DNS e DHCP, e atualizará o Firewall da entidade.
                Deve ser realizado com cautela.
              </Alert>
            </Grid>

            <Grid item xs={12}>
              <Button variant='contained' startIcon={<PlayArrowIcon />} sx={{ my: 1, py: 1 }} onClick={() => btExecutar()}>Executar</Button>
            </Grid>

          </Grid>
        </Paper>

      </Container>
    </>
  )

}
